import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import dialogPlugin, { dialog } from 'BASE/plugins/dialogPlugin';
import router from 'CJ/router';
import store from 'CJ/store/store';
import ajaxSetting from 'BASE/components/ajaxSetting.component';
import App from 'CJ/views/App.vue';
import dialogComponent from 'CJ/views/Dialog.vue';
import VueClipboard from 'vue-clipboard2';
import Loading from 'vue-loading-overlay';
import loginPlugin from 'BASE/plugins/loginPlugin';
import logoComponent from 'CJ/views/Logo.vue';
import 'vue2-datepicker/locale/zh-cn';  //統一變更時間選擇器語系
import VueCircleSlider from 'vue-circle-slider';
import datadogRumPlugin from 'BASE/plugins/datadogRumPlugin';
import UrlManager from 'BASE/common/UrlManager';
import numberPlugin from 'BASE/plugins/numberPlugin';
import vueIframe from 'BASE/plugins/vue-iframes';
import 'BASE/filters/numberFilter'; // 增加number的Filter

Vue.use(UrlManager);
Vue.use(numberPlugin);
sync(store, router);
Vue.use(dialogPlugin, { dialogComponent });
Vue.use(loginPlugin, { router, dialog });

VueClipboard.config.autoSetContainer = true; //讓vue-clipboard2將container 設置為當前元素，避免在Bootstrap 模式不工作
Vue.use(VueClipboard);

Vue.use(require('vue-moment'));

Vue.use(VueCircleSlider);
Vue.use(vueIframe);
Vue.use(Loading, {
    loader: 'spinner',
    width: 64,
    height: 64,
    zIndex: 9999,
});

Vue.use(datadogRumPlugin, { isMobile: false });

Vue.component('logo', logoComponent);

new Vue({
    router,
    store,
    render: h => h(App),
    mixins: [ajaxSetting]
}).$mount('#app');
